import { Link } from "@quintype/components";
import get from "lodash/get";
import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getCollectionitems, getMenuGroups } from "../../../../api/utils";
import { DfpComponent } from "../../ads/dfp-component";
import { HeroImage } from "../../atoms/HeroImage";
import { Label } from "../../atoms/Label";
import Newsletter from "../../atoms/Newsletter";
import { PublishAndReadTime } from "../../atoms/PublishAndReadTime";
import { useDeviceType } from "../../custom-hooks/useDeviceType";
import { getStoryHeadline, getStoryLabel, isExternalStory } from "../../utils/story";

import "./latest-news.m.css";

const StoryTextContent = ({ story }) => {
  const customStyleForReadTime = { fontFamily: "Montserrat" };
  const { sections, authors } = story;
  return (
    <div styleName={`story-box`}>
      {getStoryLabel(story) ? (
        <Label story={story} />
      ) : (
        sections?.[0]?.["display-name"] && (
          <div styleName="section-text-class">{sections?.[0]?.["display-name"].toUpperCase()}</div>
        )
      )}
      {getStoryHeadline(story) && <span styleName={`headline`}>{getStoryHeadline(story)}</span>}
      {authors?.[0]?.name && <span styleName="section-text-class">{authors?.[0]?.name.toUpperCase()}</span>}
      <PublishAndReadTime showReadTime={true} showTimestamp={true} story={story} customStyle={customStyleForReadTime} />
    </div>
  );
};

const StoryComponent = ({ story }) => {
  const externalStoryUrl = isExternalStory(story);
  const href = externalStoryUrl || `/${story?.slug}`;
  const target = externalStoryUrl ? "_blank" : "_self";
  return (
    <Link href={href} target={target}>
      <div styleName={`story-container`}>
        <div styleName={`story-image-container`}>
          <HeroImage
            story={story}
            widths={[135]}
            aspectRatio={[[4, 3]]}
            headline={getStoryHeadline(story)}
            iconSizes={{ width: 24, height: 24 }}
          />
        </div>
        <StoryTextContent story={story} />
      </div>
    </Link>
  );
};

const LatestNewsPage = (props) => {
  const [menuGroupsList, setMenuGroupsList] = useState([]);
  const initialList = props?.data?.collection?.items ? props?.data?.collection?.items : [];
  const [stories, setStories] = useState(initialList?.length > 100 ? initialList.slice(0, 100) : initialList);
  const [offset, setOffset] = useState(100);
  const [visibleItems, setVisibleItems] = useState(initialList.length > 100);
  const slug = get(props, ["data", "collection", "slug"], null);

  const sideAd1 = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "sidebar_right_1"], {}));
  const sideAd2 = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "sidebar_right_2"], {}));
  const footerAd = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "footer_1"], {}));

  const deviceType = useDeviceType();
  const isDesktop = deviceType === "desktop";

  useEffect(async () => {
    setMenuGroupsList(await getMenuGroups());
  }, []);

  const sectionMenuList = menuGroupsList?.["menu-groups"]?.["main-nav"]?.items || [];

  const coverImage = get(props, ["data", "collection", "metadata", "cover-image"], null);

  const customStyleForNewsLetter = {
    fontFamily: "Roboto Serif",
    margin: isDesktop ? "16px 0" : "32px 0px",
    width: "auto",
  };
  const newsLetterTextsStyle = {
    textAlign: isDesktop ? "left" : "center",
    fontFamily: "Roboto Serif",
  };

  const loadMoreStories = async () => {
    const limit = 99;
    const response = await getCollectionitems(slug, offset, limit);
    const { items: moreStories, totalCount } = response;
    setStories([...stories, ...moreStories]);
    setVisibleItems(offset + limit <= totalCount);
    setOffset((prevOffset) => prevOffset + 100);
  };

  return (
    <div styleName="container">
      <div styleName="stories-wrapper">
        <div styleName="stories-results">
          {stories?.map((item, index) => {
            const story = item?.story;
            return (
              <Fragment key={index}>
                <StoryComponent story={story} />
                {index !== stories.length - 1 && <div styleName="horizontal-separator"></div>}
              </Fragment>
            );
          })}

          {visibleItems < stories.length && (
            <p styleName="loadmore-button" onClick={loadMoreStories}>
              LOAD MORE
            </p>
          )}
        </div>
        <div styleName="separartor"></div>
        <div styleName="right-column">
          <div styleName="top-ad-container mobile-top-padding">
            <DfpComponent adStyleName="ad-slot-size-300x600" id={sideAd1?.id} />
          </div>
          <Newsletter
            customStyle={customStyleForNewsLetter}
            isButtonPositionLower={true}
            newsLetterTextsStyle={newsLetterTextsStyle}
          />

          <div styleName="top-ad-container mobile-bottom-padding">
            <DfpComponent adStyleName="ad-slot-size-300x250-constant" id={sideAd2?.id} />
          </div>
        </div>
      </div>
      {isDesktop && (
        <div styleName="bottom-ad-container">
          <DfpComponent adStyleName="ad-slot-size-970x250" id={footerAd?.id} />
        </div>
      )}
    </div>
  );
};

LatestNewsPage.propTypes = {
  data: PropTypes.object,
};

export { LatestNewsPage };
